import styles from "./Login.module.scss";
import { useNavigate } from "react-router-dom";
import loginApi from "../../apis/loginApi";
import { useSnackbar } from "notistack";
import { useState, useEffect } from "react";
import StorageService from "../../services/StorageService";
import axios from "axios";

export interface LoginProps {
  className?: string;
}

// const autoLogin = async () => {
//   const res = await loginApi.loginHydra({
//     password: "123456789",
//     username: "donation@reshare.vn",
//   });

//   const dataResponse = res.data.data;

//   localStorage.setItem("tokenHYDRA", dataResponse?.token);
// };

// const checkRefreshToken = async () => {
//   const tokenHYDRAInLocal = localStorage.getItem("tokenHYDRA");
//   if (tokenHYDRAInLocal) {
//     const tokenHYDRA = JSON.parse(tokenHYDRAInLocal);
//     const jwtPayload = JSON.parse(window.atob(tokenHYDRA.split(".")[1]));

//     const exp = new Date(jwtPayload.exp * 1000);
//     const now = new Date();
//     if (now > exp) {
//       await autoLogin();
//     }
//   } else {
//     await autoLogin();
//   }
// };

const Login = (props: LoginProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const login = async (e:any) => {
    e.preventDefault();
    try {

      const res = await loginApi.loginHydra({
        username,
        password
      });
      if (res.data.code === 0) {
        // Clear stale partnerData from previous sessions
        localStorage.removeItem("partnerData");
        const token = res?.data?.data?.token;
        StorageService.token = token;
        const role = localStorage.getItem("userRole");
        enqueueSnackbar("Đăng nhập thành công", { variant: "success" });

        const hostname = window.location.hostname;
        const isDev = hostname.includes("admin-donation-dev.reshare.vn");
        const isProdAdmin = hostname === "admin-donation.reshare.vn";
        const isCtv = hostname === "ctv.reshare.vn";

        const driverId = localStorage.getItem("driverId") || "";
        const driverName = localStorage.getItem("driverName") || "";
        const driverPhone = localStorage.getItem("driverPhone") || "";

        // Query params to sync token/role/driver across domains
        const syncParams = `?token=${encodeURIComponent(token || "")}&role=${encodeURIComponent(role || "")}&driverId=${encodeURIComponent(driverId)}&driverName=${encodeURIComponent(driverName)}&driverPhone=${encodeURIComponent(driverPhone)}`;

        if (role === "driver") {
          // Tài xế:
          // Nếu ở dev (admin-donation-dev.reshare.vn) -> ở lại admin-donation-dev.reshare.vn/orders-ship để test với dev backend!
          // Nếu ở prod (admin-donation.reshare.vn) -> chuyển qua domain ctv.reshare.vn
          if (isDev) {
            window.location.href = "/orders-ship";
            return;
          } else if (isProdAdmin && !isCtv) {
            window.location.href = `https://ctv.reshare.vn/orders-ship${syncParams}`;
            return;
          } else {
            window.location.href = "/orders-ship";
            return;
          }
        } else {
          // Admin: 
          // Nếu ở server dev -> admin-donation-dev.reshare.vn
          // Nếu ở prod -> admin-donation.reshare.vn
          if (isDev) {
            navigate("/");
          } else if (isCtv) {
            // Đang ở ctv.reshare.vn mà đăng nhập admin -> chuyển về domain admin
            const targetAdmin = hostname.includes("dev") ? "https://admin-donation-dev.reshare.vn" : "https://admin-donation.reshare.vn";
            window.location.href = `${targetAdmin}/${syncParams}`;
            return;
          } else if (isProdAdmin) {
            navigate("/");
          } else if (hostname.endsWith("reshare.vn")) {
            window.location.href = `https://admin-donation.reshare.vn/${syncParams}`;
            return;
          } else {
            navigate("/");
          }
        }
      }
      else{
        setError(true);
      }
    } catch (error) {
      setError(true);
      enqueueSnackbar("Lỗi hệ thống", {variant: "error"});
    }
  }

  useEffect(()=> {
    // If arriving from another domain with query params, sync them
    const params = new URLSearchParams(window.location.search);
    const paramToken = params.get("token");
    const paramRole = params.get("role");
    const paramDriverId = params.get("driverId");
    const paramDriverName = params.get("driverName");
    const paramDriverPhone = params.get("driverPhone");

    if (paramToken) {
      StorageService.token = paramToken;
      if (paramRole) {
        localStorage.setItem("userRole", paramRole);
      }
      if (paramDriverId) {
        localStorage.setItem("driverId", paramDriverId);
      }
      if (paramDriverName) {
        localStorage.setItem("driverName", paramDriverName);
      }
      if (paramDriverPhone) {
        localStorage.setItem("driverPhone", paramDriverPhone);
      }
      // Remove query params from url cleanly
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    if (StorageService.token) {
      const role = localStorage.getItem("userRole");
      if (role === "driver") {
        window.location.href = "/orders-ship";
      } else {
        window.location.href = "/";
      }
    }
  },[navigate])

  return (
    <div className={styles.root}>
      <div className={styles.loginWrap}>
        <div className={styles.login}>
          <div className={styles.loginTitle}>Login Admin Donation</div>
          <form className={styles.loginForm} onSubmit={login}>
            <div className={styles.loginFormRow}>
              <div className={styles.loginFormRowWrap}>
                <input
                  className={styles.loginFormRowInput}
                  type="text"
                  placeholder="Số điện thoại / Email"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>

            <div className={styles.loginFormRow}>
              <div className={styles.loginFormRowWrap}>
                <input
                  className={styles.loginFormRowInput}
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e)=> setPassword(e.target.value)}
                />
              </div>
            </div>
            {
              error && <i className={styles.error}>Tài khoản hoặc mật khẩu không chính xác.</i>
            }
            <div className={styles.loginFormRow}>
              <div className={styles.loginFormRowWrap}>
                <div className={styles.buttonWrap}>
                  <button className={styles.loginFormRowButton} type="submit">
                    Login
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

